// The tenant the API should use: configured explicitly, or derived from the domain the app runs on
export const getTenant = (): string => process.env.REACT_APP_TENANT || window.location.hostname
